'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:overlay');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixOverlay extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:overlay'];
        }

        set inactive(val) {
            this.setAttribute('aria-hidden', val);
            this.style.visibility = val ? 'hidden' : 'visible';
            this.setAttribute('tabindex', val ? '-1' : '0');
        }

        connectedCallback() {
            super.connectedCallback();
            this.overlayName = this.getAttr('overlay-name', { required: true });
        }

        broadcastedEventCallback(name, args = {}) {
            const eventValue = args.detail && args.detail.value;
            if (name === 'phoenix:overlay') {
                this.inactive = eventValue !== this.overlayName;

                if (eventValue === this.overlayName) {
                    this.focus();
                    this.emitEvent('phoenix:overlay:visible', {
                        bubbles: true,
                        detail: {
                            value: eventValue,
                        },
                    });
                }
            }
        }
    }

    window.customElements.define('phoenix-overlay', PhoenixOverlay);
    measure.end();
});
